<template>
  <div class="pagination">
    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="paginationData.page"
                   :page-sizes="[20, 50, 100, 500, 1000]"
                   :page-size="paginationData['per-page']"
                   :layout="layout"
                   :total="paginationData.total"
                   :small="small">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    paginationData: {
      type: Object,
      default: {
        'per-page': 1,
        total: '',
        page: 20,
      }
    },
    small: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    }
  },
  methods: {
    handleSizeChange (val) {
      this.paginationData['per-page'] = val;
      this.$emit("paginationChange", this.paginationData);
      //   this.$emit("update:perPage", this.perPage);
    },
    handleCurrentChange (val) {
      this.paginationData.page = val;
      this.$emit("paginationChange", this.paginationData);
      //   this.$emit("update:page", this.page);
    }
  },
};
</script>

<style lang="scss">
.pagination {
    // margin: 20px 0;
    padding: 4px 0;
    text-align: center;
}
</style>
